import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Profile } from 'src/model/profile.model';
import { ProfileService } from 'src/services/profile.service';

@Component({
    selector: 'app-add-profile',
    templateUrl: './add-profile.component.html',
    styleUrls: ['./add-profile.component.scss'],
    standalone: false
})
export class AddProfileComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  private profileService = inject(ProfileService);

  @Input() addProfileCustomerId: number;
  profile: Profile = new Profile();

  @Output() passEntry = new EventEmitter<any>();

  disabledSubmit = false;

  validFields() {
    const custOccupationNull = (this.profile.Occupation == undefined || this.profile.Occupation === '');
    const salaryAmountNull = (this.profile.Salary == undefined);
    // let salaryDayNull = (this.profile.SalaryDay == undefined || this.profile.SalaryDay === 0);
    const customerCodeNull = (this.profile.CustomerCode == undefined || this.profile.CustomerCode === '');

    const salaryDayInvalid = (this.profile.SalaryDay == undefined || this.profile.SalaryDay < 1 || this.profile.SalaryDay > 31);

    return (custOccupationNull || salaryAmountNull || customerCodeNull || salaryDayInvalid);
  }

  ngOnInit(): void {
    this.profile.DateCreated = new Date();
    this.profile.CustomerID = Number(this.addProfileCustomerId);
  }

  submit() {
    if (this.validFields() == true)
      this.sharedService.openAlert("Please key in all the fields correctly", ALERT_TYPE.DANGER);
    else
      this.addProfile();
  }

  async addProfile() {
    this.disabledSubmit = true;
    try {
      const p = await this.profileService.addProfile(this.profile);
      this.passEntry.emit(p);
      this.reset();
      this.sharedService.openAlert("Successfully added profile!", ALERT_TYPE.SUCCESS);
    } finally {
      this.disabledSubmit = false;
    }
  }

  reset() {
    this.activeModal.close();
  }
}
